var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.days.length)?_c('v-container',{staticClass:"pa-0"},[_c('FilterDay'),_c('ListCards')],1):_c('NoData',{attrs:{"hasItems":_vm.hasArticles,"isNotFoundPage":false,"typeData":'menu'}})}
var staticRenderFns = []

export { render, staticRenderFns }